import { axios, API, SendRequest } from '@/imports-files/common/common';

export class CommunicationCount extends SendRequest {

  async getCount() 
  {
      let url = '/api/v1/user_comm_details/unread_count';
      try {
            const result = await axios.get(url,
            {
                headers: this.customHeaderJSON()
            },
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON()
        );
        return result;
      } catch (error) {
        return error;
      }
    }
}
